/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useRef } from 'react';
import { usePopover, Overlay, DismissButton } from 'react-aria';
import PropTypes from 'prop-types';
import Element from '../../utils/Element.js';
import { PopoverWrapper } from './styledComponents.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var Popover = function Popover(props) {
  var ref = useRef(null);
  var theme = useTheme();
  var _props$popoverRef = props.popoverRef,
    popoverRef = _props$popoverRef === undefined ? ref : _props$popoverRef,
    state = props.state,
    children = props.children,
    isNonModal = props.isNonModal;
  var _usePopover = usePopover(_objectSpread(_objectSpread({}, props), {}, {
      popoverRef: popoverRef
    }), state),
    popoverProps = _usePopover.popoverProps,
    underlayProps = _usePopover.underlayProps;
  return /*#__PURE__*/jsxs(Overlay, {
    portalContainer: typeof window !== 'undefined' ? document.body : undefined,
    children: [!isNonModal && /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, underlayProps), {}, {
      style: {
        position: 'fixed',
        inset: 0
      }
    })), /*#__PURE__*/jsxs(PopoverWrapper, _objectSpread(_objectSpread({}, popoverProps), {}, {
      ref: popoverRef,
      theme: theme,
      children: [!isNonModal && /*#__PURE__*/jsx(DismissButton, {
        onDismiss: state.close
      }), children, /*#__PURE__*/jsx(DismissButton, {
        onDismiss: state.close
      })]
    }))]
  });
};
process.env.NODE_ENV !== "production" ? Popover.propTypes = {
  /**
   * Elements to render in the Popover.
   */
  children: PropTypes.node,
  /**
   * Whether the popover is non-modal, i.e. elements outside the popover may be interacted with by assistive technologies.
   */
  isNonModal: PropTypes.bool,
  /**
   * Popover state.
   */
  state: PropTypes.shape({
    /** Whether the overlay is open by default (controlled). */
    isOpen: PropTypes.bool,
    /** Whether the overlay is open by default (uncontrolled). */
    defaultOpen: PropTypes.bool,
    /** Handler that is called when the overlay's open state changes. */
    onOpenChange: PropTypes.func
  }),
  /**
   * The ref for the popover element.
   */
  popoverRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  /**
   * The ref for the element which the popover positions itself with respect to.
   */
  triggerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]).isRequired
} : undefined;

export { Popover as default };
